import React, { Component } from 'react'
import MenuIconSvg from '../icons/MenuIconSvg'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux';

export class MenuBUtton extends Component {

  getLangCode = () => {
    const langCode = localStorage.getItem('langCode');// Dili buradan alıyoruz
    return langCode === 'az' ? '/az' : '/ru';
  };
  render() {
    const langCodeId = this.getLangCode();
    const { contentData } = this.props;
    return (
      <Link to={`${langCodeId}/menu`} className='fixed bottom-[20px] left-[20px] z-[989] p-[20px_12px] w-[64px] h-[64px] bg-[#666666] rounded-[50%] hidden max-[1010px]:block font-[600] text-[#fff] text-[16px]' dangerouslySetInnerHTML={{ __html: contentData?.nav_menu }} >

      </Link>
    )
  }
}

const mapStateToProps = (state) => ({
  contentData: state.Data.contentData,
})

const mapDispatchToProps = {}
export default connect(mapStateToProps, mapDispatchToProps)(MenuBUtton)